import { useEffect } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Printer } from "lucide-react";
import ImpactReportContent from "@/components/report/ImpactReportContent";
import { useLang } from "@/lib/i18n";

export default function ImpactReportModal({ open, onOpenChange, stats }) {
  const { t } = useLang();
  useEffect(() => {
    window.dispatchEvent(new CustomEvent("bn:impact-report", { detail: open }));
    return () => window.dispatchEvent(new CustomEvent("bn:impact-report", { detail: false }));
  }, [open]);

  if (!stats) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="impact-report-modal" className="max-w-2xl rounded-2xl p-0 overflow-hidden gap-0 max-h-[92vh] flex flex-col">
        <DialogTitle className="sr-only">Executive Impact Report — CSR & Community Readiness</DialogTitle>
        <DialogDescription className="sr-only">Laporan dampak eksekutif siap presentasi untuk sponsor CSR dan mitra ESG, dapat dicetak sebagai PDF.</DialogDescription>


        <div className="overflow-y-auto">
          <ImpactReportContent stats={stats} />
        </div>

        <div className="bg-slate-50 border-t border-slate-200 p-4 flex justify-end gap-2 shrink-0">
          <Button data-testid="report-close-btn" variant="outline" onClick={() => onOpenChange(false)} className="rounded-full font-bold">{t("rp_close")}</Button>
          <Button data-testid="report-print-btn" onClick={() => window.print()}
            className="rounded-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold">
            <Printer className="w-4 h-4 mr-2" /> {t("rp_print")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
